/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Example_Input_LabelInputs */

const en_example_input_label = /** @type {(inputs: Example_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

const ko_example_input_label = /** @type {(inputs: Example_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입력`)
};

const ja_example_input_label = /** @type {(inputs: Example_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力`)
};

/**
* | output |
* | --- |
* | "Input" |
*
* @param {Example_Input_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const example_input_label = /** @type {((inputs?: Example_Input_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Example_Input_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_example_input_label(inputs)
	if (locale === "ko") return ko_example_input_label(inputs)
	return ja_example_input_label(inputs)
});